import { PlanDetailGroupOrder, PlanDetailRowsOrder } from '../PlanDetails.Types';
import { PlanDetailEntry } from 'components/PlanData/Types/GetPlanDetailsResponse.Type';

export type PlanDetailGroupEntriesProps = {
  planDetailEntries: PlanDetailEntry[];
  planDetailGroupEntryOrder: PlanDetailGroupOrder[];
  planDetailRowsOrder?: PlanDetailRowsOrder[];
};
